import { configureStore } from "@reduxjs/toolkit";
import { activityHistoryCollectionsSlice } from "../../activity-history-item/slice";
import { activityHistoryFiltersSlice } from "../../activity-history-item/filter/slice";

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const store = configureStore({
  reducer: {
    activityHistoryCollections: activityHistoryCollectionsSlice.reducer,
    activityHistoryFilters: activityHistoryFiltersSlice.reducer,
  },
  devTools: {
    name: "activity-history",
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // Disable serializable state invariant middleware
    }),
});

export const dispatch = store.dispatch;
export const getState = store.getState;
